import { FC, useEffect, useState } from "react";
import { Book, Props } from "../types";
import { Tracker } from "./Tracker";
import { useNavigate, useParams } from "react-router-dom";
import { GoBack } from "../components/GoBack";

export const TrackerScreen: FC<Props> = ({
  books,
  setBooks,
  setLastBooksRead,
  lastBooksRead,
}) => {
  const navigate = useNavigate();
  const [book, setBook] = useState<Book | undefined>();
  const { id: bookIdParam } = useParams();
  useEffect(() => {
    if (!bookIdParam || !books || !books[bookIdParam]) {
      navigate("/home");
      return;
    }
    setBook(books[bookIdParam]);
  }, [bookIdParam, setBook, books, navigate]);

  useEffect(() => {
    if (!book) {
      return;
    }
    setBooks((bs) => {
      return { ...bs, [book.id]: book };
    });
  }, [book, setBooks]);
  if (!books || !(Object.keys(books)?.length > 0)) {
    navigate("/home");
    return null;
  }
  return book ? (
    <Tracker
      book={book!}
      setBook={setBook}
      setBooks={setBooks}
      setLastBooksRead={setLastBooksRead}
    />
  ) : (
    <GoBack />
  );
};
